export const headCells = [
    { id: 'name', numeric: false, disablePadding: false, label: 'Candidate Name', minWidth: 220, sortable: true },
    { id: 'email', numeric: false, disablePadding: false, label: 'Email Address', minWidth: 250, sortable: false },
    { id: 'phone', numeric: false, disablePadding: false, label: 'Phone Number', minWidth: 250, sortable: false },
    { id: 'similarity_score', numeric: true, disablePadding: false, label: 'Similarity', minWidth: 130, sortable: true },
    { id: 'skill_score', numeric: true, disablePadding: false, label: 'Skill', minWidth: 110, sortable: true },
    { id: 'final_score', numeric: true, disablePadding: false, label: 'Final Score', minWidth: 130, sortable: true },
];

export const rowsPerPageOptionsConfig = [10, 25, 50, 100];

// (if footer is re-added and fixed)
// export const FOOTER_HEIGHT_XS = 78; 
// export const FOOTER_HEIGHT_SM = 58; 
